//Libs
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
//Componentes Material
import Grid from '@material-ui/core/Grid';
//Ícones
import BusinessIcon from '@material-ui/icons/Business';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import BuildIcon from '@material-ui/icons/Build';
//Controllers
import PermissaoController from '../controllers/PermissaoController';
//Relatórios
import RelatorioEmpresas from './relatorio/RelatorioEmpresas';

/**
 * Componente para exiber os relatórios e atalhos para o perfil Admin
 */
class DashboardAdmin extends Component {
    constructor(props) {
        super(props);
        //Controllers
        this.permissaoController = new PermissaoController();
        //Estado inicial
        this.state = {
            carregando: true,
            visualizarDashboard: false,
            cadastrarAdmin: false
        };
    }

    async componentDidMount() {
        //Consulta o perfil do usuário logado
        const visualizarDashboard = await this.permissaoController.permiteVisualizarDashboardAdmin();
        const cadastrarAdmin = await this.permissaoController.permiteCadastrarAdministradores();
        //Atualiza o status da página
        this.setState({ carregando: false, visualizarDashboard, cadastrarAdmin });
    }

    render() {
        const { visualizarDashboard, cadastrarAdmin } = this.state;

        return (
            <Fragment>
                <Grid container spacing={1} >
                    <Grid item xs={12} sm={4} >
                        <Button startIcon={<BusinessIcon />} size="large" variant="contained" color="primary" component={Link} to="/empresa/add" style={{ width: '100%' }} >Adicionar empresa</Button>
                    </Grid>
                    <Grid item xs={12} sm={4} >
                        <Button startIcon={<AssignmentIndIcon />} size="large" variant="contained" color="primary" component={Link} to="/questionario/add" style={{ width: '100%' }} >Adicionar questionário</Button>
                    </Grid>
                    {
                        cadastrarAdmin &&
                            <Grid item xs={12} sm={4} >
                                <Button startIcon={<BuildIcon />} size="large" variant="contained" color="primary" component={Link} to="/administrador/add" style={{ width: '100%' }} >Adicionar administrador</Button>
                            </Grid>
                    }
                </Grid>
                {
                    visualizarDashboard &&
                        <Grid container spacing={1} >
                            <RelatorioEmpresas />
                        </Grid>
                }
            </Fragment>
        );
    }
}

export default DashboardAdmin;